import gql from 'graphql-tag';

const GET_SALESFORCE_OPPORTUNITY_ID_BY_PROPOSAL_NUMBER = gql`
  query GetSalesforceOpportunityIdByProposalNumber($proposalNumber: String!) {
    getSalesforceOpportunityIdByProposalNumber(proposalNumber: $proposalNumber)
  }
`;

export default GET_SALESFORCE_OPPORTUNITY_ID_BY_PROPOSAL_NUMBER;
